import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3b1a9ef0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-patrol" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "descriptions-group" }
const _hoisted_7 = { class: "descriptions-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "所在河流:", -1))
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "descriptions-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "所在镇街:", -1))
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "descriptions-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "网格员名称:", -1))
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "descriptions-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "联系电话:", -1))
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "descriptions-item width100" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "重点监管点:", -1))
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "descriptions-group form" }
const _hoisted_23 = { class: "descriptions-item time" }
const _hoisted_24 = { class: "descriptions-item count" }
const _hoisted_25 = { class: "info" }
const _hoisted_26 = { class: "info" }
const _hoisted_27 = { class: "descriptions-item width100" }
const _hoisted_28 = { class: "descriptions-item pagination width100" }
const _hoisted_29 = { class: "pagination-info" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "descriptions-group" }, null, -1))

import { toRefs, nextTick, getCurrentInstance, onMounted, h } from 'vue'
import { ref } from 'vue-demi'
import { Api } from '@/api/publicApi'
import Bus from '@/config/Bus'

export default /*#__PURE__*/_defineComponent({
  __name: 'DialogPatrol',
  props: {
  data: Object,
},
  setup(__props) {

const { proxy } = getCurrentInstance()
const props = __props
const record = ref({})
const api = new Api()
const { data } = toRefs(props)
const range = ref([new Date(new Date() - 15 * 24 * 3600 * 1000).getTime(), new Date().getTime()])
const tableData = ref({
  pageCount: ref(1),
  pageSize: ref(4),
  itemCount: ref(0),
  data: ref([]),
})
const columns = ref([
  {
    title: '序号',
    key: 'index',
    width: 70,
    align: 'center',
    render(row, index) {
      return h(
        `span`,
        {},
        {
          default: () => index + 1,
        }
      )
    },
  },
  {
    title: '开始时间',
    key: 'beginTime',
    align: 'center',
  },
  {
    title: '结束时间',
    key: 'endTime',
    align: 'center',
  },
  {
    title: '总里程（m）',
    key: 'xhlc',
    align: 'center',
    width: 115,
  },
  {
    title: '总时长',
    key: 'zsc',
    align: 'center',
  },
  {
    title: '上报问题数',
    key: 'reportProblemCount',
    align: 'center',
  },
])

const onFilterChange = (val) => {
  console.log(val)
  console.log(range)
  api.screen
    .getGridXcRecordDtoUsingPost({
      beginTime: format(val[0]),
      endTime: format(val[1]),
      userId: props.data.userId,
    })
    .then((res2) => {
      if (res2.code === 200 && res2.data) {
        record.value = res2.data
        tableData.value.data = res2.data.records
        tableData.valueitemCount = res2.data.records ? res2.data.records.legnth : 0
      } else {
      }
    })
}

function add0(m) {
  return m < 10 ? '0' + m : m
}
function format(shijianchuo) {
  //shijianchuo是整数，否则要parseInt转换
  const time = new Date(shijianchuo)
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()
  // var h = time.getHours();
  // var mm = time.getMinutes();
  // var s = time.getSeconds();
  // return y+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);
  return y + '-' + add0(m) + '-' + add0(d)
}

function rowProps(row) {
  return {
    style: 'cursor: pointer;',
    onClick: () => {
      Bus.emit('showModal', {
        modalType: '巡查详情',
        data: row,
      })
      // alert(6)
    },
  }
}

onMounted(() => {
  onFilterChange(range.value)
})

return (_ctx: any,_cache: any) => {
  const _component_n_date_picker = _resolveComponent("n-date-picker")!
  const _component_n_data_table = _resolveComponent("n-data-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString('巡查记录' + ' 【' + _unref(data).qdmc + '~' + _unref(data).zdmc + '】'), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(data).hl || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(data).szzjmc || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(data).zrrUserName || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(data).zrrUserTel || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(data).prints || '-'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_n_date_picker, {
              value: _unref(range),
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(range) ? (range).value = $event : null)),
              type: "daterange",
              clearable: "",
              onChange: onFilterChange
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("span", _hoisted_25, "应巡 " + _toDisplayString(_unref(record).yxs || '-') + " 次", 1),
            _createElementVNode("span", _hoisted_26, "已巡 " + _toDisplayString(_unref(record).sxs || '-') + " 次", 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_n_data_table, {
              columns: _unref(columns),
              "max-height": 400,
              data: _unref(tableData).data,
              bordered: true,
              "row-props": rowProps
            }, null, 8, ["columns", "data"])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("span", _hoisted_29, "共 " + _toDisplayString(_unref(tableData).data.length) + " 项数据", 1)
          ])
        ]),
        _hoisted_30
      ])
    ])
  ]))
}
}

})